import { Slider } from '@material-ui/core';
import useInput from 'lib/hooks/useInput';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';

const UnitSlider = ({
  data,
  step = 0.01,
  defaultValue = 0,
  min,
  max,
  digit = 5,
  valueVisible = true,
  disabled = false,
  ariaLabelledby = '',
  width = '100%',
  // onChange = (e, newVal) => {},
  onValueChange = newVal => {},
}) => {
  const sliderValue = useInput(data);

  useEffect(() => {
    if (data !== sliderValue.value) {
      sliderValue.setValue(data);
    }
  }, [data]);

  // const onChange = useCallback(
  //   (e, newVal) => {
  //     sliderValue.setValue(newVal);

  //     if (onValueChange) {
  //       onValueChange(sliderValue.value);
  //     }
  //   },
  //   [sliderValue.value, onValueChange],
  // );

  const onChange = useCallback((e, newVal) => {
    sliderValue.setValue(newVal);
  }, []);

  const onChangeCommitted = useCallback(
    (e, newVal) => {
      // sliderValue.setValue(newVal);

      if (onValueChange) {
        onValueChange(sliderValue.value);
      }
    },
    [sliderValue.value, onValueChange],
  );

  if (data !== 0 && !data) return null;
  return (
    <StyledUnitSlider data-component-name="UnitSlider" width={width}>
      <Slider
        disabled={disabled}
        defaultValue={defaultValue}
        aria-labelledby={ariaLabelledby}
        // value={Number(data)}
        value={Number(sliderValue.value)}
        // getAriaValueText={() => Number(data.value).toFixed(2)}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        // onChange={(e, newVal) => sliderValue.setValue(newVal)}
        valueLabelDisplay="auto"
        step={step}
        marks
        min={min}
        max={max}
        className="unitSlider"
      />
      {valueVisible && (
        <input
          // value={
          //   data.value !== '-'
          //     ? Number(data.value).toFixed(2)
          //     : data.value
          // }
          value={
            String(sliderValue.value)?.includes('-')
              ? String(sliderValue.value).slice(0, digit)
              : String(sliderValue.value).slice(0, digit - 1)
          }
          // onChange={sliderValue.onChange}
          onChange={e => {
            // console.log('[kkw] e.target.value', e.target.value);

            onValueChange(e.target.value);
            return sliderValue.setValue(e.target.value);
          }}
          className="input-reset unitSlider__value"
          onBlur={() => {
            if (sliderValue.value === '' || isNaN(sliderValue.value)) {
              onValueChange(defaultValue);
              // return sliderValue.setValue(defaultValue);
            } else {
              if (sliderValue.value < min) {
                onValueChange(min);
                // return sliderValue.setValue(min);
              }
              if (sliderValue.value > max) {
                onValueChange(max);
                // return sliderValue.setValue(max);
              }
              // return data.setValue(draft => Number(draft).toFixed(2));
            }
          }}
        />
      )}
      {/* <span className="unitSlider__value">{data.value}</span> */}
    </StyledUnitSlider>
  );
};

UnitSlider.propTypes = {
  // data: PropTypes.object.isRequired,
  data: PropTypes.number.isRequired,
  step: PropTypes.number,
  defaultValue: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  digit: PropTypes.number,
  valueVisible: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default React.memo(UnitSlider);

const StyledUnitSlider = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  width: ${({ width }) => (width && typeof width === 'string' ? width : width && width + 'px')};
  height: 40px;
  .unitSlider {
    width: calc(100% - 55px);
    color: ${color.blue};
    &:after,
    &:before {
      content: '';
      display: inline-block;
      z-index: 1;
      position: absolute;
      margin-top: -3px;
      width: 8px;
      height: 8px;
      background-color: ${color.blue};
      border-radius: 50%;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: -2px;
    }
    .MuiSlider-thumb {
      z-index: 2;
      width: 16px;
      height: 16px;
      background-color: white;
      border: 4px solid ${color.blue};
      margin-top: -7px;
      margin-left: -8px;
      .MuiSlider-valueLabel {
        left: calc(-50% - 8px);
      }
    }
    .MuiSlider-markActive {
      background-color: ${color.blue};
    }
    &.Mui-disabled {
      &:after,
      &:before {
        background-color: ${color.gray_b5};
      }
      .MuiSlider-thumb {
        border-color: ${color.gray_b5};
      }
    }
  }
  .unitSlider__value {
    width: 45px;
    margin-left: 10px;
    /* margin-top: -2px; */
    /* padding-bottom: 2px; */
    /* border-bottom: 1px solid ${color.gray_font}; */
    padding: 4px 0;
    background-color: #f4f5fa;
    border-radius: 5px;
    text-align: center;
    font-size: 13px;
  }
`;
